import { SelectFields } from '@repo/toolkit/types'

import { AffectedStaff } from '../../models/affectedStaff/affected-staff'
import { FieldsSelector } from '../../utils'

export const affectedStaffBaseFields = [
  'id',
  'staff.firstName',
  'staff.lastName',
  'phoneNumber',
  'startDate',
  'endDate'
] as const satisfies FieldsSelector<AffectedStaff>

export type AffectedStaffBaseType = SelectFields<AffectedStaff, typeof affectedStaffBaseFields>

export const affectedStaffMainFields = [
  'id',
  'staff.firstName',
  'staff.lastName',
  'phoneNumber'
] as const satisfies FieldsSelector<AffectedStaff>

export type AffectedStaffMainType = SelectFields<AffectedStaff, typeof affectedStaffMainFields>

export const affectedStaffCenterPlacementFields = [
  'id',
  'facNumber'
] as const satisfies FieldsSelector<AffectedStaff>

export type AffectedStaffCenterPlacementType = SelectFields<
  AffectedStaff,
  typeof affectedStaffCenterPlacementFields
>

export const affectedStaffTravelScheduleFields = [
  'id',
  'staff.firstName',
  'staff.lastName',
  'phoneNumber'
] as const satisfies FieldsSelector<AffectedStaff>

export type AffectedStaffTravelScheduleType = SelectFields<
  AffectedStaff,
  typeof affectedStaffTravelScheduleFields
>

export const affectedStaffOlCenterTableFields = [
  'id',
  'status',

  'hostFamily.id',
  'hostFamily.parent1FirstName',
  'hostFamily.parent1LastName',
  'hostFamily.lecComments.sharedToOl',

  'staff.firstName',
  'staff.lastName',
  'staff.phoneNumber',
  'staff.position',
  'staff.picture.path',
  'staff.birthDate',
  'staff.gender',
  'staff.user.email',

  'staffRequest.qualification',
  'staffRequest.centers.centerToJourneys.journey.id' as keyof AffectedStaff,
  'staffRequest.centers.centerToJourneys.journey.date.departureDate' as keyof AffectedStaff,

  'hostFamilyHistory.updatedAt',
  'hostFamilyHistory.date',
  'hostFamilyHistory.reasonForChange',
  'hostFamilyHistory.diffusedToParentsAt',
  'hostFamilyHistory.hostFamily.id',
  'hostFamilyHistory.hostFamily.parent1FirstName',
  'hostFamilyHistory.hostFamily.parent1LastName'
] as const satisfies FieldsSelector<AffectedStaff>

export type AffectedStaffOlCenterTableType = SelectFields<
  AffectedStaff,
  typeof affectedStaffOlCenterTableFields
>
